import React from "react";
import "../ResultTradeDuration/ResultTradeDuration.scss";
import ReactTable from "../../Table";
import CandleGraphs from "../../../reusableComponents/CandleGraphs/CandleGraphs";
import { FormatUSD } from "../../../utils/helpers/string";

const LongShortComp = ({ data }) => {
  // Validate data
  const isValidData = Array.isArray(data) && data.length > 0;

  // Extract categories and series data
  const categories = isValidData ? data.map((item) => item[0]) : [];
  const seriesData1 = isValidData
    ? data.map((item) => item[1]?.results || 0)
    : [];

  const comp_data = {
    data: seriesData1,
    time: categories,
  };

  // Prepare table data
  const tableData = isValidData
    ? data.map((item, index) => ({
      key: index.toString(),
      instrument: item[0],
      number_of_trade: item[1]?.number_of_trade || 0,
      results: item[1]?.results || 0,
      long_trade: item[1]?.long_trade || 0,
      long_result: item[1]?.long_result || 0,
      short_trade: item[1]?.short_trade || 0,
      short_result: item[1]?.short_result || 0,
    }))
    : [];

  const columns = [
    {
      Header: "Instruments",
      accessor: "instrument",
      Cell: ({ value }) => (
        <div className="instrument-cell">
          <span className="flag-placeholder"></span>
          {value}
        </div>
      ),
      sortable: true,
    },
    {
      Header: "No. of Trades",
      accessor: "number_of_trade",
      sortable: true,
    },
    {
      Header: "Result",
      accessor: "results",
      Cell: ({ value }) => {
        const result = Number(value) || 0;
        return (
          <span className={result < 0 ? "negative_value" : "positive_value"}>
           {FormatUSD(result)}
          </span>
        );
      },
      sortable: true,
    },
    {
      Header: "Long Trades",
      columns: [
        {
          Header: "No. of Trades",
          accessor: "long_trade",
          sortable: true,
        },
        {
          Header: "Result",
          accessor: "long_result",
          Cell: ({ value }) => {
            const result = Number(value) || 0;
            return (
              <span
                className={result < 0 ? "negative_value" : "positive_value"}
              >
               {FormatUSD(result)}
              </span>
            );
          },
          sortable: true,
        },
      ],
    },
    {
      Header: "Short Trades",
      columns: [
        {
          Header: "No. of Trades",
          accessor: "short_trade",
          sortable: true,
        },
        {
          Header: "Result",
          accessor: "short_result",
          Cell: ({ value }) => {
            const result = Number(value) || 0;
            return (
              <span
                className={result < 0 ? "negative_value" : "positive_value"}
              >
               {FormatUSD(result)}
              </span>
            );
          },
          sortable: true,
        },
      ],
    },
  ];

  return (
    <div className="resultTradeDurationMain">
      <div className="profit-in-duration">
        <div className="trade-reports">
          <div className="header_Wrapper">
            <h2 className="component-heading">Results by Instruments</h2>
          </div>
          <div className="chart-box-wrapper">
            <div className="tabs-wrapper">
              <div className="chart-box">
                <CandleGraphs
                  data={comp_data}
                  dataSymbol="amount"
                  graphType="amount"
                  title="Symbol"
                  aria-label="Chart showing results by instruments"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="duration-result">
        <div className="trade-duration">
          <ReactTable
            columns={columns}
            data={tableData}
            variant={2}
            aria-label="Table showing trade results by instruments"
          />
        </div>
      </div>
    </div>
  );
};

export default LongShortComp;
